<style lang="scss" scoped>
</style>

<template>
    <div class="col-12 d-flex flex-column align-items-center justify-content-center">
        <component :is="type" class=""></component>
        <h1 class="fs-20 fw-b mt-30 mb-30">
            <slot name="title"></slot>
        </h1>
        <p class="fs-15 mb-0 d-flex flex-column text-center">
            <slot name="description"></slot>
        </p>
    </div>
</template>

<script>

export default {
    props: {
        type: {
            type: String,
            required: false,
            default: 'i-empty-container'
        }
    }
};
</script>
